import { render, staticRenderFns } from "./ClassSubjectTeacherEdit.vue?vue&type=template&id=0bce24f4&"
import script from "./ClassSubjectTeacherEdit.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjectTeacherEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports